import { render, staticRenderFns } from "./Pratice.vue?vue&type=template&id=701065c4"
import script from "./Pratice.vue?vue&type=script&lang=ts"
export * from "./Pratice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports